import React, { useEffect, useRef, useState } from "react";
import { GiHamburgerMenu } from "react-icons/gi";
import { Link, Redirect } from "react-router-dom";
import jwtDecode from "jwt-decode";
import { CSSTransition } from "react-transition-group";
import ManageDialog from "./manage/manage";
import MenuComp from "./menu.comp";
import SearchIcon from "../../../../components/icons/SearchIcon";

import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { getMenuDatas } from "./menu.config";
import "./header.css";
import { userLogin as sendOtp } from "../../../../pages/auth/login/auth.api";
import SearchModal from "./searchmodal";
import ResetPasswordModal from "./resetPasswordModal";
import { Modal, Button } from "react-bootstrap";

export default function Header(props) {
  const activelocation = sessionStorage.getItem("active_path");
  let lang = props.state.language;
  const dropdownRef = useRef(null);

  const [openMenu, setOpenMenu] = useState(props.menuState);
  const [searchResults, setSearchResults] = useState([]);
  const [openProfile, setOpenProfile] = useState(props.prof);
  const [openDialog, setOpenDialog] = useState(false);
  const [activeItem, setActiveItem] = useState({});
  const [activeMenu, setActiveMenu] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [showSearch, setShowSearch] = useState(false);
  const [showResetPassword, setShowResetPassword] = useState(false);
  const [showLoginInfo, setShowLoginInfo] = useState(false);
  const words = ["Directory", "Register", "Market Research"];
  const [dynamicWordIndex, setDynamicWordIndex] = useState(0);
  const history = useHistory();
  let userData = props.state.payload ? jwtDecode(props.state.payload) : null;

  useEffect(() => {
    setOpenMenu(props.menuState);
  }, [props.menuState]);

  useEffect(() => {
    setOpenProfile(props.prof);
  }, [props.prof]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setSearchResults([]);
        setShowSearch(false);
        setSearchQuery("");
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setDynamicWordIndex((prevIndex) => (prevIndex + 1) % words.length);
    }, 2000);

    return () => clearInterval(interval);
  }, [words.length]);

  const handlelanguage = () => {
    let swicthlan = props.state.language === "en" ? "SWITCHMAL" : "SWITCHENG";
    props.setlang(swicthlan);
  };

  const updateBody = (value) => {
    props.setMenu(value);
  };

  const updateProf = (value) => {
    props.setProf(value);
  };

  const closeDialog = () => {
    setOpenDialog(false);
  };

  const handleMenuClick = (e, data) => {
    e.stopPropagation();
    sessionStorage.setItem("active_path", data.path);
    if (data.next) {
      sessionStorage.setItem("next_path", data.next);
    } else {
      sessionStorage.setItem("next_path", "/dashboard");
    }
    if (data.isDirect) {
      setOpenDialog(false);
      props.history.push(data.path);
    } else {
      setOpenDialog(true);
      setActiveItem(data);
    }
    setOpenMenu(false);
    setActiveMenu(null);
  };

  const handleCloseMenu = () => {
    setOpenMenu(false);
  };

  const handleLogin = () => {
    props.userLogin();
  };

  const handleResetPassword = async () => {
    updateProf(false);
    setShowResetPassword(true);
  };

  const handleSearchToggle = () => {
    setShowSearch(!showSearch);
    setSearchQuery("");
    setSearchResults([]);
  };

  const handleSearchChange = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);

    if (query.length > 0) {
      const searchResults = [];

      const searchMenu = (menuItems) => {
        menuItems.forEach((menu) => {
          if (menu?.children?.length > 0) {
            menu.children.forEach((child) => {
              const name = lang === "ma" ? child.label_ma : child.label_en;

              if (name && name.toLowerCase().includes(query)) {
                searchResults.push({
                  id: child.id || Math.random(),
                  name: name,
                  path: child.path || "#",
                });
              }
            });

            searchMenu(menu.children);
          }
        });
      };

      const MenuDatas = getMenuDatas(props.state.isUserAuthenticated);
      if (Array.isArray(MenuDatas)) {
        searchMenu(MenuDatas);
      }

      setSearchResults(searchResults);
    } else {
      setSearchResults([]);
    }
  };

  const handleResultClick = (result) => {
    setSearchQuery(result.name);
    setSearchResults([]);
    setShowSearch(false);
    if (result.path && result.path !== "#") {
      history.push(result.path);
    }
    setShowSearch(false);
  };

  return (
    <header className="main-header">
      <div className="header-container-fluid">
        {/* Left Section: Menu & Government Logos */}
        <div className="header-left-section">
          <div className="pt-3">
            <div
              className="new-menuIcon-cont"
              onClick={() => {
                setOpenMenu(!openMenu);
                updateProf(false);
                updateBody(!openMenu);
                setActiveMenu(null);
              }}
            >
              <GiHamburgerMenu className="header-menu-icon menu-cont" />
            </div>
            <div className="menu-head-text-cont hide-mobile">
              <div>Menu</div>
            </div>
          </div>

          <div
            className="gov-logos-container hide-mobile"
            onClick={() => {
              setOpenMenu(false);
              props.history.push("/");
            }}
          >
            <img
              src="/resources/logo/kg.png"
              className="header-logo-image-kg"
              alt="Government of Kerala Logo"
            />
            <img
              src="/resources/logo/kit.png"
              className="kit-logo"
              alt="KSPACE/KIT Logo"
            />
          </div>
        </div>

        {/* Center Section: Spacepark Logo & Title */}
        <div
          className="header-center-section"
          onClick={() => {
            setOpenMenu(false);
            props.history.push("/");
          }}
        >
          <img
            src="/latest-logo.png"
            className="header-logo-image logo-link h-100"
            alt="Kerala Spacepark Logo"
          />
          <div className="header-title hide-mobile logo-link">
            Kerala Spacepark
          </div>
        </div>

        {/* Right Section: Socials, Lang, Search, Profile */}
        <div className="header-right-section" ref={dropdownRef}>
          {/* Social Icons - Hidden on small mobile */}
          <div className="social-links-wrapper hide-mobile-social">
            <div className="social-icon-btn" onClick={() => window.open("https://facebook.com/keralaspacepark", "_blank")} aria-label="Facebook">
              <i className="fab fa-facebook-f"></i>
            </div>
            <div className="social-icon-btn" onClick={() => window.open("https://x.com/keralaspacepark", "_blank")} aria-label="Twitter">
              <img src="/twitter.png" alt="x" className="twitter-symbol" />
            </div>
            <div className="social-icon-btn" onClick={() => window.open("https://youtube.com/@keralaspacepark", "_blank")} aria-label="Youtube">
              <i className="fab fa-youtube"></i>
            </div>
            <div className="social-icon-btn" onClick={() => window.open("https://instagram.com/keralaspacepark", "_blank")} aria-label="Instagram">
              <i className="fab fa-instagram"></i>
            </div>
            <div className="social-icon-btn" onClick={() => window.open("https://linkedin.com/company/keralaspacepark", "_blank")} aria-label="Linkedin">
              <i className="fab fa-linkedin-in"></i>
            </div>
          </div>

          <div className="actions-wrapper">
            {/* Language Toggle */}
            <button className="lang-toggle-btn" onClick={handlelanguage}>
              {props.state.language === "en" ? "ML" : "EN"}
            </button>

            {/* Search Icon Trigger */}
            <button className="search-trigger-btn" onClick={handleSearchToggle} aria-label="Search">
              <SearchIcon />
            </button>

            {/* User Profile / Login Area */}
            <div className="user-action-container">
              {!props.state.isValid ? (
                props.state.isUserAuthenticated ? (
                  <div className="profile-trigger-wrapper">
                    <button
                      className="user-avatar-btn"
                      onClick={() => updateProf(!openProfile)}
                      aria-label="User Profile Menu"
                    >
                      {(() => {
                        const name = userData?.user?.name;
                        if (!name || typeof name !== "string") return "U";
                        return name.charAt(0).toUpperCase();
                      })()}
                    </button>
                    {openProfile && (
                      <div className="profile-dropdown-menu">
                        <div className="dropdown-user-info">
                          <span className="dropdown-username">{userData?.user?.name || "User"}</span>
                          <span className="dropdown-userrole">{userData?.user?.email || ""}</span>
                        </div>
                        <div className="dropdown-divider"></div>
                        <button
                          className="dropdown-item-btn"
                          onClick={() => {
                            updateProf(false);
                            props.history.push("/dashboard");
                          }}
                        >
                          <i className="fa fa-tachometer-alt dropdown-icon"></i>
                          Dashboard
                        </button>

                        {userData?.multiple && (
                          <button
                            className="dropdown-item-btn"
                            onClick={() => {
                              updateProf(false);
                              props.history.push("/switch-account");
                            }}
                          >
                            <i className="fa fa-exchange-alt dropdown-icon"></i>
                            Switch Account
                          </button>
                        )}

                        {userData?.user?.is_company_user === true && (
                          <button
                            className="dropdown-item-btn"
                            onClick={handleResetPassword}
                          >
                            <i className="fa fa-key dropdown-icon"></i>
                            Reset Password
                          </button>
                        )}
                        <div className="dropdown-divider"></div>
                        <button
                          className="dropdown-item-btn logout"
                          onClick={() => {
                            updateProf(false);
                            props.logout();
                            props.history.push("/");
                          }}
                        >
                          <i className="fa fa-sign-out-alt dropdown-icon"></i>
                          Logout
                        </button>
                      </div>
                    )}
                  </div>
                ) : (
                  <div className="login-btn-container">
                    <button className="login-primary-btn" onClick={handleLogin}>
                      <i className="fa fa-sign-in-alt login-btn-icon"></i>
                      LOGIN
                    </button>
                    {/* <span className="login-caption-text">For Registered Users</span> */}
                  </div>
                )
              ) : (
                <button
                  className="cancel-action-btn"
                  onClick={() => {
                    props.logout();
                    props.history.push("/");
                  }}
                >
                  Cancel
                </button>
              )}
            </div>
          </div>
        </div>
      </div>

      {openMenu && (
        <MenuComp
          {...props}
          handleMenuClick={handleMenuClick}
          userData={userData}
          activeMenu={activeMenu}
          setActiveMenu={setActiveMenu}
          handleClose={handleCloseMenu}
          auth={props.state.isUserAuthenticated}
        />
      )}

      <ManageDialog
        {...props}
        open={openDialog}
        data={activeItem}
        handleClose={closeDialog}
      />

      <SearchModal
        setPaymentOpen={setShowSearch}
        searchResults={searchResults}
        paymentOpen={showSearch}
        handleResultClick={handleResultClick}
        searchQuery={searchQuery}
        handleSearchChange={handleSearchChange}
        showSearch={showSearch}
      />

      <ResetPasswordModal
        show={showResetPassword}
        onHide={() => setShowResetPassword(false)}
        token={props.state?.payload}
      />
    </header>
  );
}
